export const CONSENT_STORAGE_KEY = "khalfan_cookie_consent";
export const CONSENT_ACCEPTED = "accepted";
export const CONSENT_REJECTED = "rejected";
export const OPEN_COOKIE_PREFERENCES_EVENT = "khalfan:open-cookie-preferences";

let currentPageChoice = null;

const isValidChoice = (choice) =>
  choice === CONSENT_ACCEPTED || choice === CONSENT_REJECTED;

export function getConsentChoice() {
  try {
    const choice = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (isValidChoice(choice)) return choice;
  } catch {
    // Fall back to the choice made during this page view.
  }
  return currentPageChoice;
}

export function hasAnalyticsConsent() {
  return getConsentChoice() === CONSENT_ACCEPTED;
}

function getConsentUpdate(choice) {
  return {
    analytics_storage: choice === CONSENT_ACCEPTED ? "granted" : "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  };
}

function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
}

export function saveConsentChoice(choice) {
  if (!isValidChoice(choice)) {
    throw new Error("Invalid cookie consent choice");
  }

  currentPageChoice = choice;
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, choice);
  } catch {
    // Apply the choice for this page even when browser storage is unavailable.
  }

  ensureGtag();
  window.gtag("consent", "update", getConsentUpdate(choice));

  if (choice === CONSENT_ACCEPTED) {
    window.khalfanLoadGTM?.();
  }
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT));
}
